import styled from 'styled-components'

import media from '../../../utils/media'

const POLYGONS = {
  BEFORE: {
    'to-left': '0% 0%, 0% 100%, 100% 0%',
    'to-right': '0% 0%, 100% 0%, 100% 100%'
  },
  AFTER: {
    'to-left': '0% 0%, 0% 100%, 100% 0%',
    'to-right': '0% 0%, 100% 0%, 100% 100%'
  },
  AFTER30: {
    'to-left': '0% 0%, 0% 100%, 100% 0%',
    'to-right': '0% 0%, 100% 0%, 30% 100%'
  },
  CENTER: {
    'to-left': '0 0, 100% 70%, 100% 100%, 0% 100%',
    'to-right': '0 70%, 100% 0, 100% 100%, 0% 100%'
  }
}

export const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  height: auto;

  ${({ marginTop }) =>
    marginTop &&
    `
      margin-top: ${marginTop}px;
  `}

  ${({ paddingTop }) =>
    paddingTop &&
    `
      padding-top: ${paddingTop}px;
  `}

  ${({ paddingBottom }) =>
    paddingBottom &&
    `
      padding-bottom: ${paddingBottom}px;
  `}

  ${({ paddingLeft }) =>
    paddingLeft &&
    `
      padding-left: ${paddingLeft}px;
  `}

  ${({ paddingRight }) =>
    paddingRight &&
    `
      padding-right: ${paddingRight}px;
  `}

  ${({ theme, bgColor }) =>
    bgColor &&
    `
      background-color: ${theme.color[bgColor]};
  `}

  ${({ theme, bgColor, beforeSkew }) =>
    beforeSkew &&
    `
      &:before {
        content: '';
        width: 100%;
        height: 100px;
        display: block;
        position: absolute;
        z-index: 1;
        left: 0;
        right: 0;
        top: -99px;
        clip-path: polygon(${POLYGONS.BEFORE[beforeSkew]});
        background-color: ${theme.color[bgColor]};
      }
  `}

${({ theme, bgColor, beforeSkewInvert }) =>
  beforeSkewInvert &&
  `
      &:before {
        content: '';
        width: 100%;
        height: 100px;
        display: block;
        position: absolute;
        z-index: 1;
        left: 0;
        right: 0;
        top: -99px;
        clip-path: polygon(${POLYGONS.BEFORE[beforeSkewInvert]});
        background-color: ${theme.color[bgColor]};
        transform: rotateX(180deg);
      }
  `}

  ${({ theme, bgColor, afterSkew, zindexAfter, bottom }) =>
    afterSkew &&
    `
      &:after {
        content: '';
        width: 100%;
        height: 100px;
        display: block;
        position: absolute;
        z-index: ${zindexAfter || 1};
        left: 0;
        right: 0;
        bottom: ${bottom || -99}px;
        clip-path: polygon(${POLYGONS.AFTER[afterSkew]});
        background-color: ${theme.color[bgColor]};
      }
  `}

${({ theme, bgColor, afterSkew30 }) =>
  afterSkew30 &&
  `
      &:after {
        content: '';
        width: 100%;
        height: 100px;
        display: block;
        position: absolute;
        z-index: 1;
        left: 0;
        right: 0;
        bottom: -99px;
        clip-path: polygon(${POLYGONS.AFTER30[afterSkew30]});
        background-color: ${theme.color[bgColor]};
      }
  `}


  ${({ theme, bgImage, bgGradient }) => {
    const bg = []

    if (bgImage) {
      bg.push(`url(${bgImage})`)
    }

    if (bgGradient) {
      bg.push(`linear-gradient(to top right,
        ${theme.color[bgGradient[0]]},
        ${theme.color[bgGradient[1]]})`)
    }

    if (bgImage || bgGradient) {
      return `
        background-clip: padding-box;
        background-image: ${bg.join(', ')};

        &:after,
        &:before {
          background-image: linear-gradient(to top right,
            ${theme.color[bgGradient[0]]},
            ${theme.color[bgGradient[1]]}
          );
        }
      `
    }
  }}

  ${media.lessThan('sm')`
    ${({ beforeSkew }) =>
      beforeSkew &&
      `
        &:before {
          height: 50px;
          top: -49px;
        }
    `}

  `}

  &.page {
    &-differential {
      .section-heading {
        padding-bottom: 80px;
        position: relative;
        overflow: hidden;

        .title {
          margin-top: 8px;
          position: relative;
          z-index: 200;
        }

        .shape-line-waves {
          left: 10%;
          bottom: -75%;
        }
        .shape-circle {
          right: calc(15% + 25px);
          bottom: 110px;
        }
        .shape-half-circle {
          right: 10%;
          bottom: -50%;
        }
      }
    }

    ${media.lessThan('md')` 
      &-differential {
        .section-heading {
          .shape-line-waves {
            left: -20%;
          }
          .shape-circle {
            right: 25px;
          }
          .shape-half-circle {
            right: -10%;
          }
        }
      }
    `}

    ${media.lessThan('sm')`
      &-differential {
        padding-top: 110px;

        .section-heading {
          padding-bottom: 50px;
          .shape-line-waves {
            left: -50%;
          }
          .shape-circle {
            right: -15px;
          }
          .shape-half-circle {
            right: -25%;
          }
        }
      }
    `}
  }

  &.product {
    &-features {
      .product-features-list {
        position: relative;
      }

      .section-content {
        > .shape-line-waves {
          top: -40px;
          left: -100px;
          z-index: -1;
        }

        > .shape-line-circle {
          top: -40px;
          right: -60px;
          z-index: -1;
        }
      }

      .section-retract {
        position: relative;
        z-index: 10;
        transform: translateY(200px);
      }
    }

    &-differential {
      overflow: hidden;

      &:before {
        content: '';
        width: 120vw;
        height: 90%;
        background-image: url('./assets/images/condo/condo-differential-bg.png');
        position: absolute;
        background-position: center;
        background-size: 130vw;
        top: 100px;
        left: -10vw;
        right: -10vw;
        margin: 0 auto;
        z-index: 1;
      }

      > div {
        position: relative;
        z-index: 2;
      }
    }

    &-cta {
      > div {
        position: relative;
      }

      .section-content {
        position: relative;
        z-index: 10;
      }

      .shape-line-circle {
        top: -20px;
        left: -30px;
      }

      .shape-half-circle {
        bottom: -20px;
        right: -30px;
      }
    }

    &-pjbank {
      overflow: hidden;

      > div {
        &:before,
        &:after {
          content: '';
          width: 50%;
          position: absolute;
          z-index: 1;
          background-size: contain;
          background-repeat: no-repeat;
        }

        &:before {
          bottom: 0;
          left: -150px;
          height: 40%;
          background-position: center bottom;
          background-image: url('./assets/images/condo/condo-pjbank-line-1.svg');
        }

        &:after {
          top: 0;
          right: -100px;
          height: 80%;
          background-position: center top;
          background-image: url('./assets/images/condo/condo-pjbank-line-2.svg');
        }
      }

      .section-heading,
      .section-content,
      .section-footing {
        position: relative;
        z-index:2;
      }
    }

    &-cta-box {
      .section-content {
        position: relative;
        z-index: 20;
      }
    }

    &-testimonials {
      .section-content {
        position: relative;
        z-index: 10;
      }

      .shape-circle {
        z-index: -1;
        top: -300px;
        right: 0;
      }

      .shape-line-circle {
        z-index: -1;
        top: -50px;
        left: -50px;
      }

      &:before,
      &:after {
        height: 50%;
        top: auto;
        bottom: -1px;
      }

      &:before {
        clip-path: polygon(${({ beforeSkew }) => POLYGONS.CENTER[beforeSkew]});
        background-color: ${({ theme }) => theme.color.neutral200};
      }

      &:after {
        clip-path: polygon(${({ afterSkew }) => POLYGONS.CENTER[afterSkew]});
        background-color: ${({ theme }) => theme.color.neutral300};
      }
    }
  }

  ${media.greaterThan('md')`
    &.product {
      &-infobanner {
        .section-heading {
          padding-left: 32px;
          transform: translateY(80px);
          margin-bottom: 0;
        }

        .infobanner {
          transform: translateY(31%);
        }
      }
    }
  `}

  ${media.lessThan('lg')`
    &.product {
      &-differential {
        &:before {
          top: 80px;
        }
      }
    }
  `}

  ${media.lessThan('md')`
    &.product {
      &-differential {
        &:before {
          top: -80px;
        }
      }

      &-infobanner {
        .section-heading {
          transform: translateY(100px);
        }

        .infobanner {
          transform: translateY(17%);
        }
      }

      &-cta-box {
        .illustration-wrapper {
          margin-bottom: 48px;
        }
      }
    }
  `}

  ${media.lessThan('sm')`
    &.product {
      &-features {
        padding-top: 0;
        text-align: center;

        .section-retract {
          transform: translateY(100px);
        }

        .section-heading {
          margin-right: auto;
          margin-left: auto;
        }

        .section-content {
          flex-direction: column;
        }

        .tile {
          &:first-of-type {
            margin-bottom: 32px;
          }
        }
      }

      &-differential {
        padding-top: 215px;

        &:before {
          background-size: 180vw;
          height: 600px;
          top: 180px;
        }
      }

      &-infobanner {
        padding-top: 80px;

        .section-heading {
          transform: translateY(0);
          text-align: center;
        }

        .section-content {
          margin-top: 40px;
        }

        .tile {
          margin-top: 40px;
        }

        .infobanner {
          transform: translateY(0);
        }
      }

      &-testimonials {
        .shape-circle {
          top: -230px;
          right: -95px;
        }
      }

      &-press {
        padding-top: 80px;
        padding-bottom: 60px;
      }

      &-cta-box {
        padding-top: 80px;
        padding-bottom: 0;
      }
    }
  `}

  ${media.lessThan('xs')`
    &.product {
      &-cta {
        .shape-line-circle {
          top: -20px;
        }

        .shape-half-circle {
          width: 100px;
          height: 100px;
          bottom: 20px;
          z-index: 1;
        }
      }

      &-differential {
        &:before {
          height: 500px;
        }
      }
    }
  `}

  ${media.lessThan('xxs')`
    &.product {
      &-differential {
        &:before {
          top: 140px;
        }
      }
    }
  `}
`

export const SectionHeadingWrapper = styled.header`
  display: flex;
  align-items: ${({ align }) => align};
  flex-direction: ${({ direction }) => direction};

  ${({ align }) =>
    align === 'center' &&
    `
    text-align: center;
  `}

  ${({ marginTop }) =>
    marginTop &&
    `
      margin-top: ${marginTop}px;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
      margin-bottom: ${marginBottom}px;
  `}
`

export const SectionContentWrapper = styled.article`
  position: relative;
  display: flex;
  align-items: ${({ align }) => align};
  flex-direction: ${({ direction }) => direction};
  justify-content: ${({ justify }) => justify};
  z-index: 2;

  ${({ marginTop }) =>
    marginTop &&
    `
      margin-top: ${marginTop}px;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
      margin-bottom: ${marginBottom}px;
  `}
`

export const SectionFootingWrapper = styled.footer`
  width: 100%;
  display: flex;
  align-items: ${({ align }) => align};
  flex-direction: ${({ direction }) => direction};

  ${({ align }) =>
    align === 'center' &&
    `
    text-align: center;
  `}

  ${({ marginTop }) =>
    marginTop &&
    `
      margin-top: ${marginTop}px;
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
      margin-bottom: ${marginBottom}px;
  `}
`
